import React from 'react';
import { Users, ShieldCheck, Leaf, ThumbsUp } from 'lucide-react';
export function TrustBar() {
  const items = [{
    icon: <Users className="w-8 h-8" data-id="element-96" />,
    text: '100.000+ zufriedene Kunden'
  }, {
    icon: <ThumbsUp className="w-8 h-8" data-id="element-97" />,
    text: 'Mit Tierärzten entwickelt'
  }, {
    icon: <Leaf className="w-8 h-8" data-id="element-98" />,
    text: '100% pflanzlich & natürlich'
  }, {
    icon: <ShieldCheck className="w-8 h-8" data-id="element-99" />,
    text: 'Geld-zurück-Garantie'
  }];
  return <section className="py-12 bg-forestGreen text-cream" data-id="element-100">
      <div className="max-w-6xl mx-auto px-4" data-id="element-101">
        <div className="grid grid-cols-2 md:grid-cols-4 gap-8" data-id="element-102">
          {items.map((item, idx) => <div key={idx} className="flex flex-col items-center text-center gap-3" data-id="element-103">
              <div className="bg-cream/10 p-4 rounded-full" data-id="element-104">{item.icon}</div>
              <span className="font-serif font-medium text-sm md:text-base" data-id="element-105">
                {item.text}
              </span>
            </div>)}
        </div>
      </div>
    </section>;
}